import React from "react"
import { cn } from "../../lib/utils"

export function ShineBorder({ className, duration = "4s", colors = ["#fef08a", "#c084fc", "#f9a8d4", "#fef08a"] }) {
  return <span aria-hidden="true" className={cn("pointer-events-none absolute -inset-0.5 overflow-hidden rounded-[inherit]", className)}><span className="absolute -inset-[100%] animate-spin" style={{ animationDuration: duration, background: `conic-gradient(from 0deg, ${colors.join(", ")})` }} /></span>
}
